import debit_card from "assets/images/debit_card.svg";
import rafahia_card from "assets/images/rafahia_card.svg";

export const isEverythingUnique = (arr, key) => {
  const uniques = new Set(arr.map(item => item[key]));
  return [...uniques].length === arr.length;
}

export const ASSETS_BASE_URL= 'https://www.alrajhibank.com.my/';

export const personalMenu = [
  {
    id: 1,
    title: "Deposits",
    parent: "/personal/deposits",
    children: [
      {
        type: "TYPES OF DEPOSITS",
        children: [
          {
            title: "<span>Savings Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/savings-account",
          },
          {
            title: "<span>Current Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/current-account",
          },
          {
            title: "<span>Commodity Murabahah Term Deposit<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/commodity-murabahah-td-i",
          },
          {
            title:
              "<span>Commodity Murabahah Savings Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/commodity-murabahah-sa-i",
          },
          {
            title:
              "<span>Commodity Murabahah Current Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/commodity-murabahah-ca-i",
          },
          {
            title:
              "<span>Commodity Murabahah Foreign Currency Current Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/deposits/commodity-murabahah-fc-ca-i",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Cards",
    parent: "/personal/cards",
    children: [
      {
        type: "TYPES OF CARDS",
        children: [
          {
            title: "<span>alrajhi bank Malaysia Debit Card<span class='no-wrap'>-<em>i</em></span></span>",
            image: debit_card,
            path: "/personal/cards/debit-card",
          },
          {
            title: "<span>alrajhi bank Malaysia Rafahia Card<span class='no-wrap'>-<em>i</em></span></span>",
            image: rafahia_card,
            path: "/personal/cards/rafahia-card",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Financing",
    parent: "/personal/financing",
    children: [
      {
        type: "TYPES OF PERSONAL FINANCING",
        children: [
          {
            title: "<span>Personal Financing<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/financing/personal-financing-i",
          },
          {
            title: "<span>Personal Financing-&nbsp;<em>i</em> Umrah</span>",
            path: "/personal/financing/personal-financing-i-umrah",
          },
          {
            title:
              "<span>Personal Financing-&nbsp;<em>i</em> Secured by Term Deposit<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/financing/personal-financing-td-i",
          },
          {
            title: "Personal Financing Employee Benefit Scheme (EBS)",
            path: "/personal/financing/personal-financing-i-ebs",
          },
          {
            title:
              "<span>Corporate Community Select Programme - Salary Deduction (CCSP<span class='no-wrap'>-SD)</span></span>",
            path: "/personal/financing/personal-financing-i-ccsp-sd",
          },
        ],
      },
      {
        type: "TYPES OF PROPERTY FINANCING",
        children: [
          {
            title: "<span>Home Financing<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/financing/home-financing-i",
          },
          {
            title: "Home One Account",
            path: "/personal/financing/home-one-account",
          },
          {
            title: "<span>Business Premises Financing<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/financing/business-financing",
          },
          {
            title: "Historical Trend of Reference Rate Since January 2015",
            path: "/personal/financing/historical-trend",
          },
        ],
      },
      {
        type: "OTHER",
        children: [
          {
            title: "<span>Cashline<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/financing/cashline-i",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: "Wealth Management",
    parent: "/personal/wealth",
    children: [
      {
        type: "TYPES OF WEALTH MANAGEMENT",
        children: [
          {
            title: "<span>Gold<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/wealth/gold-i",
          },
          {
            title: "<span>GoldInvest<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/wealth/gold-invest",
          },
          { title: "Unit Trust", path: "/personal/wealth/unit-trust" },
          {
            title: "<span>Structured Product<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/wealth/structured-product",
          },
          {
            title: "BancaTakaful",
            children: [
              { title: "Sinar Kasih", path: "/personal/wealth/sinar-kasih" },
              {
                title: "Sinar Link Aiman",
                path: "/personal/wealth/sinar-link-aiman",
              },
              // {
              //   title: "Sinar Baraqah",
              //   path: "/personal/wealth/sinar-baraqah",
              // },
              // {
              //   title: "Sinar Health Plan",
              //   path: "/personal/wealth/sinar-health-plan",
              // },
            ],
          },
          { title: "Will Writing", path: "/personal/wealth/will-writing" },
          {
            title: "<span>Safe Deposit Box<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/personal/wealth/safe-deposit-box",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Digital",
    children: [
      {
        type: "WAYS TO BANK",
        children: [
          {
            title: "MY alrajhi",
            path: "/MY-alrajhi",
          },
          {
            title: "alrajhibank@24seven",
            path: "/digital/alrajhi-24seven",
          },
          { title: "Rize", path: "/rize/personal" },
        ],
      },
    ],
  },
  {
    id: 7,
    title: "Others",
    parent: ["/personal/others", "/services", "/e-application-form", "/enquiry"],
    children: [
      {
        type: "AFFLUENT",
        children: [
          {
            title: "Affluent Proposition",
            path: "/personal/others/affluent-proposition",
          },
        ],
      },
      {
        type: "FORMS",
        children: [
          { title: "E-Application Forms", path: "/e-application-form" },
          { title: "Product Enquiry", path: "/enquiry" },
        ],
      },
      {
        type: "SERVICES",
        children: [
          { title: "ATM Services", path: "/services/atm" },
          { title: "MEPS Services", path: "/services/meps-atm" },
          {
            title: "e-Payment Services",
            path: "/business/cash-management/e-payment",
          },
          {
            title: "Cheque Deposit Services",
            path: "/services/cheque-deposit",
          },
          {
            title: "SMS Notification Alerts",
            path: "/services/sms-notifications",
          },
          { title: "Service Request Form", path: "/services/request-form" },
        ],
      },
    ],
  },
];

export const businessMenu = [
  {
    id: 1,
    title: "Treasury",
    parent: "/business/treasury",
    children: [
      {
        type: "TREASURY",
        children: [
          { title: "Deposits", path: "/business/treasury/deposit" },
          {
            title: "Foreign Exchange",
            path: "/business/treasury/foreign-exchange",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Deposits",
    parent: "/business/deposits",
    children: [
      {
        type: "TYPES OF DEPOSITS",
        children: [
          {
            title: "<span>Current Account-&nbsp;<em>i</em>",
            path: "/business/deposits/current-account",
          },
          {
            title: "<span>Commodity Murabahah Term Deposit<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/deposits/term-deposit-i",
          },
          {
            title: "<span>Floating Rate Term Deposit<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/deposits/floating-rate-td",
          },
          {
            title:
              "<span>Commodity Murabahah Current Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/deposits/commodity-murabahah-biz",
          },
          {
            title:
              "<span>Commodity Murabahah Foreign Currency Current Account<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/deposits/commodity-murabahah-biz-fc",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Financing",
    parent: "/business/financing",
    children: [
      {
        type: "TYPES OF FINANCING",
        children: [
          {
            title: "<span>Cashline<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/financing/cashline",
          },
          {
            title: "<span>Commodity Financing<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/financing/commodity-financing",
          },
          {
            title: "<span>Structured Commodity Financing<span class='no-wrap'>-<em>i</em></span></span>",
            path: "/business/financing/structured-commodity",
          },
          {
            title: "Trade Finance",
            path: "",
            children: [
              {
                title: "<span>Letter of Credit<span class='no-wrap'>-<em>i</em></span></span>",
                path: "/business/financing/trade-financing/letter-of-credit",
              },
              {
                title: "<span>Shipping Guarantee<span class='no-wrap'>-<em>i</em></span></span>",
                path: "/business/financing/trade-financing/shipping-guarantee",
              },
              {
                title: "<span>Bank Guarantee<span class='no-wrap'>-<em>i</em></span></span>",
                path: "/business/financing/trade-financing/bank-guarantee",
              },
              {
                title: "<span>Trade Commodity Financing<span class='no-wrap'>-<em>i</em></span></span>",
                path: "/business/financing/trade-financing/trade-commodity",
              },
              {
                title: "<span>Bills for Collection<span class='no-wrap'>-<em>i</em></span></span>",
                path: "/business/financing/trade-financing/bill-collection",
              },
            ],
          },
          {
            title: "Syndication Financing",
            path: "/business/financing/syndication-financing",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: "Global Markets",
    parent: "/business/global-markets",
    children: [
      {
        type: "TYPES OF GLOBAL MARKETS",
        children: [
          { title: "Financial Institution", path: "/business/global-markets" },
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Cash Management",
    parent: "/business/cash-management",
    children: [
      {
        type: "TYPES OF CASH MANAGEMENT",
        children: [
          {
            title: "alrajhicashbiz@24seven",
            path: "/business/cash-management/alrajhi-cashbiz",
          },
          { title: "e-Payment", path: "/business/cash-management/e-payment" },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Enquiry Form",
    path: "/enquiry",
  },
];

export const aboutUsMenu = [
  {
    id: 1,
    title: "Corporate Info",
    parent: "/corporate-info",
    children: [
      {
        type: "",
        children: [
          // { title: "Overview", path: "/about/corporate-info/overview" },
          // { title: "Our Background", path: "/about/corporate-info/our-background" },
          { title: "Our Values", path: "/about/corporate-info/our-values" },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Corporate Profile",
    parent: "/corporate-profile",
    children: [
      {
        type: "",
        children: [
          {
            title: "Board of Directors",
            path: "/about/corporate-profile/board-of-directors",
          },
          { title: "Shariah Board", path: "/about/corporate-profile/shariah-board" },
          {
            title: "Executive Management",
            path: "/about/corporate-profile/executive-management",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Corporate Governance",
    parent: "/corporate-governance",
    children: [
      {
        type: "",
        children: [
          {
            title: "Compliance & AML Statement",
            path: "/about/corporate-governance/compliance",
          },
          {
            title: "Whistleblowing Policy",
            path: "/about/corporate-governance/whistleblow",
          },
          { title: "FACTA/CRS", path: "/about/corporate-governance/fatca-crs" },
          { title: "Disclosure", path: "/about/corporate-governance/disclosure" },
        ],
      },
    ],
  },
  {
    id: 4,
    parent: "/news",
    title: "News & Announcements",
    path: "/news",
  },
];

export const digitalBankingMenu = [
  {
    id: 1,
    title: "MY alrajhi",
    path: "/MY-alrajhi",
    parent: "/MY-alrajhi",
  },
  {
    id: 2,
    title: "Rize",
    path: "/rize/personal",
  },
  {
    id: 3,
    title: "alrajhi@24seven",
    path: "/digital/alrajhi-24seven",
    parent: "/digital/alrajhi-24seven",
  },
  {
    id: 4,
    title: "alrajhicashbiz@24seven",
    path: "/business/cash-management/alrajhi-cashbiz",
    parent: "/business/cash-management/alrajhi-cashbiz",
  },
];

export const rizeMenu = [
  {
    id: 1,
    title: "Personal",
    path: "/rize/personal",
    parent: "/rize/personal",
  },
  {
    id: 2,
    title: "Support",
    path: "/rize/support",
    parent: "/rize/support",
  },
  {
    id: 3,
    title: "Campaigns",
    path: "/rize/promotions",
    parent: "/rize/promotions",
  },
  {
    id: 4,
    title: "Fraud Awareness",
    path: "/rize/fraud-awareness",
    parent: "/rize/fraud-awareness",
  },
];

export const tabItems = [
  { id: 0, name: "Personal", path: "/",item: personalMenu },
  { id: 1, name: "Business",path: "/business/treasury/deposit",item: businessMenu },
  { id: 3, name: "Digital", path: "/digital-banking-overview",item: digitalBankingMenu },
  { id: 2, name: "About Us", path: "/about",item: aboutUsMenu },
];
